<template>
    <el-dialog class="dialog-blank"
               center
               append-to-body
               :show-close="false"
               data-testid="sales-information-dialog"
               :visible.sync="internalDialogVisible"
               custom-class="sales-information-dialog"
               @close="hideDialog">
        <div class="sales-info-box">
            <div class="sales-info-box-header">
                <span class="sales-info-box-icon">
                    🎉
                </span>
                <span class="sales-info-box-title">
                    Your Aloware Account is Now Active!
                </span>
            </div>
            <p class="sales-info-box-content">
                You're all set to start making calls, closing deals, and scaling your business.
            </p>
            <div class="sales-info-box-content">
                <p class="mb-2">
                    <strong>🚀 Ready to unlock more?</strong><br>
                    Our Sales team can help you upgrade your plan or add powerful features tailored to your goals.
                </p>
                <p class="mb-2">
                    <strong>🤖 AloAi Agents & Voice Analytics</strong><br>
                    Automate lead follow-ups, transcribe every call, and unlock AI-powered insights — all available through powerful recurring add-ons that scale with your business.
                </p>
                <p class="mb-2">
                    <strong>📍 Local Presence</strong><br>
                    Increase your answer rates with geo-matching numbers.
                </p>
                <p class="mb-2">
                    <strong>🛡️ NumberGuard</strong><br>
                    Monitor and reduce spam flagging on your numbers.
                </p>
                
                <div class="text-center mt-4 mb-4">
                    <el-button type="primary" 
                               class="connect-sales-button" 
                               @click="connectWithSales">
                        Connect with Sales
                    </el-button>
                </div>
                
                <div class="helpful-resources">
                    <p class="mb-2">
                        <strong>📚 Helpful Resources</strong>
                    </p>
                    <p class="mb-2 resource-item">
                        <span class="resource-icon">🤖</span>
                        <a href="https://aloware.com/solutions/ai-voice-agent" target="_blank">
                            Scale your business with AloAi Voice Agent
                        </a>
                    </p>
                    <p class="mb-2 resource-item">
                        <span class="resource-icon">📈</span>
                        <a href="https://aloware.com/blog/aloai-voice-analytics-making-data-driven-conversations-simple" target="_blank">
                            AloAi Voice Analytics: Making data-driven conversations simple
                        </a>
                    </p>
                    <p class="mb-2 resource-item">
                        <span class="resource-icon">📍</span>
                        <a href="https://aloware.com/blog/local-presence" target="_blank">
                            How Local Presence brings your calls closer to home: Making every call feel local and recognizable
                        </a>
                    </p>
                    <p class="mb-2 resource-item">
                        <span class="resource-icon">🛡️</span>
                        <a href="https://aloware.com/solutions/numberguard" target="_blank">
                            Protect your numbers with NumberGuard
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'sales-information-dialog',

    props: {
        dialogVisible: {
            type: Boolean,
            required: true
        }
    },

    data () {
        return {
            internalDialogVisible: this.dialogVisible
        }
    },

    methods: {
        hideDialog () {
            this.internalDialogVisible = false
        },
        
        connectWithSales () {
            window.open('https://meetings.hubspot.com/alwr/aloware-demo', '_blank')
            this.hideDialog()
        }
    },

    watch: {
        dialogVisible (newVal) {
            this.internalDialogVisible = newVal
        },
        internalDialogVisible (newVal) {
            this.$emit('update:dialogVisible', newVal)
        }
    }
}
</script>

<style scoped>
.sales-info-box {
    padding: 24px;
    background-color: white !important;
    word-break: break-word;

    .sales-info-box-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }

    .sales-info-box-icon {
      font-size: 24px;
      margin-right: 12px;
    }

    .sales-info-box-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
}

.sales-info-box-content {
    color: #333;
    margin-bottom: 16px;
}

.helpful-resources {
    background-color: #f5f7fa;
    padding: 16px;
    border-radius: 8px;
    margin-top: 16px;
}

.helpful-resources strong {
    font-size: 16px;
}

.helpful-resources .resource-item {
    display: flex;
    align-items: flex-start;
}

.helpful-resources .resource-icon {
    margin-right: 8px;
    flex-shrink: 0;
}

.helpful-resources a {
    color: #409EFF;
    text-decoration: underline;
    line-height: 1.5;
    font-weight: 500;
}

.helpful-resources a:hover {
    color: #66b1ff;
}

.connect-sales-button {
    font-size: 16px !important;
    font-weight: bold !important;
    padding: 12px 24px !important;
}
</style> 